module.exports = __webpack_public_path__ + "dist/img/usbank-logo.5917f313.png";